
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';

//COMPONENTS
import KogAutoCompleteControlled from '@/main/components/shared/inputAutoComplete/autoCompleteControlled';

//REDUX/UTILS
import { KeyValue } from '@/main/models/common';
import { getDefaultOptionDrop, getGoogleRecaptchaPublicKey, getPhoneCountryCode, getTranslateByFullKey, getTranslateByKey, isNullUndefined, removeEmptyValues } from '@/main/services/utils';
import { getCountriesPublic, useCountryReducer } from '@/main/store/country';

// STYLES/COMPONENTS LOCAL
import KogInputTextControlledNew from '@/main/components/shared/inputText/inputTextControlledNew';
import * as S from './styles';
import { countryInfoApi, homePagePublicApi, recaptchaAPI } from '@/main/api';
import { DemoInfoPublicRequest } from '@/main/models/request/demoInfoPublicRequest';
import * as SHomepage from '../components/styles';
import { getCompanyTypePublic, useCompanyTypeReducer } from '@/main/store/companyType';
import { Link } from 'react-router-dom';
import KogCheckBoxControlled from '@/main/components/shared/checkbox/checkBoxControlled';
import isEmail from 'validator/lib/isEmail';
import ButtonDemo from '../components/buttonDemo/buttonDemo';
import { CompanyTypeEnum } from '@/main/services/enum/CompanyTypeEnum';
import image1 from '@/main/assets/images/homepage/asset@3x.png';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { ENUM_ERROR_EMAIL } from '../../register/registerSteps/utilsSteps';
import { CustomError } from '@/main/services/class/customError';
import { uppercaseFirstLetter } from '@/main/services/utilsString';
import { RoutesConstants } from '@/main/routes/routesConstants';


const INITIAL_FORM_STATE_DEFAULT = {
  country: null as KeyValue | null,
  companyType: null as KeyValue | null,
  name: '',
  lastName: '',
  email: '',
  companyName: '',
  employeesNumber: '',
  phone: '',
  position: '',
  idCulture: '',
  agreeCommunication: false,
  codePhoneNumber: null as KeyValue | null,
};
type IFormFiltersDemo = typeof INITIAL_FORM_STATE_DEFAULT

function HomePageDemoScreen({
}) {

  // #region Hooks
  const dispatch = useDispatch();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const methods = useForm<IFormFiltersDemo>({
    mode: 'all',
    defaultValues: INITIAL_FORM_STATE_DEFAULT
  })
  const {
    control,
    handleSubmit,
    setValue,
    watch: watchForm
  } = methods;
  const watchCountry = watchForm('country');
  const watcherButton = watchForm('agreeCommunication');


  // #endregion
  // #region reducers
  const { countriesPublic: countryReducer } = useCountryReducer();
  const { companyTypePublic: companyTypeReducer } = useCompanyTypeReducer();
  const translatesRedux = useSelector((state: any) => state.translate);
  // #endregion

  // #region States
  const optionDefaultCountry = getDefaultOptionDrop(countryReducer.data)
  const [isLoadingSave, setIsLoadingSave] = useState<boolean>(false)

  // #endregion

  // #region Core Functions
  function resetForm() {
    methods.reset()
    if (optionDefaultCountry) setValue('country', optionDefaultCountry)
    setValue('companyType', null)
    setValue('name', '')
    setValue('lastName', '')
    setValue('email', '')
    setValue('companyName', '')
    setValue('employeesNumber', '')
    setValue('phone', '')
    setValue('position', '')
    setValue('idCulture', '')
    setValue('agreeCommunication', false)
    setValue('codePhoneNumber', null)
  }

  function handleClickLink() {
    window.scrollTo({ top: 0 })
  }
  // #endregion

  const cultureBrowser = translatesRedux.translates.cultureUserLogged;

  function loadInfoCountry() {
    if (isNullUndefined(watchCountry)) return;
    countryInfoApi.getCountryInfoPublic(String(watchCountry.key)).then(response => {
      const {
        data: { result }
      } = response;
      const codeCountry = getPhoneCountryCode();
      const findCodePhoneNumber = codeCountry.find(
        item => item.key === result.dialingCode
      ) as KeyValue;
      setValue('codePhoneNumber', findCodePhoneNumber);
    });
  }

  function editCompanyTypeInfo() {
    if (isNullUndefined(companyTypeReducer.data)) return []
    const dataWidthOutAdmin = companyTypeReducer.data.filter(item => item.key !== String(CompanyTypeEnum.Admin))
      .map(item => ({
        ...item,
        value: getTranslateByKey(item.value.replace('t.nah.', ''))
      }));
    const otherOption: KeyValue = {
      key: String(CompanyTypeEnum.Other),
      value: getTranslateByKey('reason.other')
    }
    const result = [...dataWidthOutAdmin, otherOption]
    return result
  }

  function formatOptionsCountries() {
    if (isNullUndefined(countryReducer.data)) return [];

    const result = countryReducer.data?.map(item => ({
      ...item,
      value: getTranslateByFullKey(item.valueTranslate)
    }));
    const resultOrdered = result.sort((a, b) => a.value.localeCompare(b.value));
    return resultOrdered;
  }

  async function validateRecaptcha() {
    if (!executeRecaptcha) return;
    const token = await executeRecaptcha();
    const response = await recaptchaAPI.validateRecaptcha(token);
    const {
      data: { result }
    } = response;
    const isValidCaptcha = result;

    if (!isValidCaptcha) {
      const message = getTranslateByKey("information.failReCaptcha", true);
      throw new CustomError(message, ENUM_ERROR_EMAIL.CAPTCHA)
    }

    return isValidCaptcha;
  }

  // #region Async functions
  async function onSubmitSave(data: IFormFiltersDemo) {
    setIsLoadingSave(true)
    const request: DemoInfoPublicRequest = removeEmptyValues({
      guidCountry: data.country?.key,
      idCompanyType: data.companyType?.key,
      name: data.name,
      lastName: data.lastName,
      email: data.email,
      companyName: data.companyName,
      employeesNumber: data.employeesNumber,
      phone: `${data.codePhoneNumber?.value ?? ''} ${data.phone}`,
      position: data.position,
      idCulture: cultureBrowser,
      agreeCommunication: data.agreeCommunication
    });

    const isValidCaptcha = await validateRecaptcha();
    if (!isValidCaptcha) return false;

    homePagePublicApi
      .registerDemoinfoPublic(request)
      .then((response) => {
        toast.success(getTranslateByKey('information.SuccessDemo'));
        resetForm();
      })
      .finally(() => {
        setIsLoadingSave(false)
      });
  }
  // #endregion

  // #region UseEffects
  useEffect(() => {
    if (isNullUndefined(countryReducer.data)) dispatch(getCountriesPublic())
    if (isNullUndefined(companyTypeReducer.data)) dispatch(getCompanyTypePublic())
  }, [])

  useEffect(() => {
    loadInfoCountry();
  }, [watchCountry?.key]);

  // #endregion

  const optionCompanyTypeFilter = editCompanyTypeInfo();
  const optionsCountryTranslate = formatOptionsCountries();

  return (
    <SHomepage.FirstSection $backgroundImage={''}>
      <S.Container>
        <S.AreaText>
          <S.FieldTextInitial
            data-aos='fade-up'
            data-aos-delay='100'
          >
            {getTranslateByKey('information.FormtextDemo')}
          </S.FieldTextInitial>
          <S.TitleLandingPage
            data-aos='fade-up'
            data-aos-delay='200'
          >
            {getTranslateByKey('information.DemoTitle')}
          </S.TitleLandingPage>
          <S.FieldText
            data-aos='fade-up'
            data-aos-delay='300'
          >
            {getTranslateByKey('information.TextField')}
          </S.FieldText>
          <S.ImageLine src={image1}></S.ImageLine>
        </S.AreaText>
        <form onSubmit={handleSubmit(onSubmitSave)} noValidate>
          <S.AreaForm
            data-aos='fade-up'
          >
            <KogInputTextControlledNew
              id="id-demo-txt-name"
              name="name"
              label={getTranslateByKey('information.name')}
              control={control}
              inputProps={{ maxLength: 50 }}
              controllerProps={{ rules: { required: true, maxLength: 50 } }}
            />
            <KogInputTextControlledNew
              id="id-demo-txt-lastname"
              name="lastName"
              label={getTranslateByKey('information.lastName')}
              control={control}
              inputProps={{ maxLength: 50 }}
              controllerProps={{ rules: { required: true, maxLength: 50 } }}
            />
            <KogInputTextControlledNew
              name="email"
              label={getTranslateByKey('information.email')}
              control={control}
              inputProps={{ maxLength: 50 }}
              controllerProps={{
                rules: {
                  required: true,
                  maxLength: 50,
                  validate: {
                    isEmail: value =>
                      isEmail(value) ||
                      getTranslateByKey('information.invalidEmail', true)
                  }
                }
              }}
            />
            <KogInputTextControlledNew
              id="id-demo-txt-company"
              name="companyName"
              label={getTranslateByKey('information.company')}
              control={control}
              inputProps={{ maxLength: 50 }}
              controllerProps={{ rules: { required: true, maxLength: 50 } }}
            />
            <S.AreaInputNumber>
              <KogInputTextControlledNew
                hasOnlyNumber
                id="id-demo-txt-employeesNumber"
                name="employeesNumber"
                label={getTranslateByKey('information.EmployeesNumber')}
                control={control}
                inputProps={{ maxLength: 9 }}
                controllerProps={{ rules: { required: false, maxLength: 20 } }}
              />
            </S.AreaInputNumber>
            <KogAutoCompleteControlled
              id="id-holiday-select-country-register"
              nameCustom="country"
              label={getTranslateByKey('information.country')}
              isDefaultValueUnique
              valueDefaultKey={optionDefaultCountry?.key}
              control={control}
              rulesCustom={{ required: true }}
              setValueCustom={setValue}
              options={optionsCountryTranslate}
              isLoading={countryReducer.isLoading}
              onChangeCustom={() => { }}
            />
            <S.AreaInputNumber>
              <KogInputTextControlledNew
                hasOnlyNumber
                name="phone"
                label={getTranslateByKey('information.phone')}
                control={control}
                inputProps={{ maxLength: 12 }}
                controllerProps={{
                  rules: { required: false, maxLength: 12, minLength: 10 }
                }}
                id="id-register-txt-phoneNr"
                InputProps={{
                  startAdornment: (
                    <KogAutoCompleteControlled
                      label={''}
                      nameCustom="codePhoneNumber"
                      control={control}
                      options={getPhoneCountryCode()}
                      isLoading={false}
                      onChangeCustom={() => { }}
                      id="id-register-txt-codePhoneNumber"
                      disableClearable={true}
                    />
                  )
                }}
              />
            </S.AreaInputNumber>
            <KogInputTextControlledNew
              id="id-demo-txt-position"
              name="position"
              inputProps={{ maxLength: 50 }}
              label={getTranslateByKey('information.position')}
              control={control}
              controllerProps={{ rules: { required: true, maxLength: 50 } }}
            />
            <KogAutoCompleteControlled
              id="id-demo-select-companytype"
              nameCustom="companyType"
              label={getTranslateByKey('information.Sector')}
              isDefaultValueUnique
              control={control}
              rulesCustom={{ required: true }}
              setValueCustom={setValue}
              options={optionCompanyTypeFilter}
              isLoading={companyTypeReducer.isLoading}
              onChangeCustom={() => { }}
            />
            <S.FieldText2>
              {getTranslateByKey('information.Formtext2')}
            </S.FieldText2>
            <S.FieldCheckBox>
              <KogCheckBoxControlled
                nameCustom="agreeCommunication"
                label={getTranslateByKey('information.Formtext3')}
                control={control}
                color='primary'
                id="id-register-checkBox-acceptDemo"
              />
            </S.FieldCheckBox>
            <S.FieldPrivacePolicy>
              {getTranslateByKey('information.Formtext4')}
              &nbsp;
              <Link
                to={RoutesConstants.homepagePrivacyPolicy}
                onClick={handleClickLink}
              >
                <u>{uppercaseFirstLetter(getTranslateByKey('information.PrivacyPolicy')) + '.'}</u>
              </Link>
            </S.FieldPrivacePolicy>
            <ButtonDemo
              id="id-demo-btn-save"
              type="submit"
              disabled={!watcherButton}
              isLoading={isLoadingSave}>
              {getTranslateByKey('information.LetsTalk')}
            </ButtonDemo>
          </S.AreaForm>
        </form>
      </S.Container>
    </SHomepage.FirstSection>
  );
}

function HomePageDemoWrapper() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={getGoogleRecaptchaPublicKey()}>
      <HomePageDemoScreen></HomePageDemoScreen>
    </GoogleReCaptchaProvider>
  );
}
export default HomePageDemoWrapper